import { updateBeginWorkStep } from 'src/providers/UpdateBeginWorkStepsProvider';
import { BEGIN_WORK_STEPS_IDS } from 'src/constants/beginWorksSteps';

import useGoTo from 'src/hooks/useGoTo';

import CollectionsContent from '../Collections/Content';

export default function Collections() {
    const goTo = useGoTo();

    const onSuccessHandler = () => {
        updateBeginWorkStep({
            currentStep: BEGIN_WORK_STEPS_IDS.CHOOSE_COLLECTIONS,
            onSuccess: () => {
                goTo('/begin_work/chats_and_channels');
            },
        });
    };

    return (
        <CollectionsContent
            onSuccess={onSuccessHandler}
            isOnboarding
        />
    );
}
